import { FC } from 'react';
import { BrandedIcon } from '../../brandedIcon/BrandedIcon';
import { IconTooltipProps } from './model/IconTooltipProps';
import { ClickableTooltip } from './ClickableTooltip';

/**
 * The IconTooltip can be used when you want information to be shown in a tooltip when the user hovers or clicks an icon.
 *
 * The icon will be clickable when no mouse is detected on the device.
 *
 * @param title - the tooltip content. If title is undefined - null will be returned
 * @param onlyClickable - will only show tooltip when user clicks the icon
 * @param tooltipProps - extra customisation of the tooltip
 * @param name - the icon name
 */
export const IconTooltip: FC<IconTooltipProps> = ({ title, onlyClickable, tooltipProps, placement, ...props }) => (
  <ClickableTooltip title={title} onlyClickable={onlyClickable} placement={placement} {...tooltipProps}>
    <BrandedIcon {...props} />
  </ClickableTooltip>
);
